import { Box, type Theme } from '@mui/material';
import { TemperatureAdjustButton } from './temperature-adjust-button';
import { TemperatureInput } from './temperature-input';

interface TemperatureInputControlsProps {
  temperature: number | undefined;
  validation: { isCompliant: boolean; message: string } | null | undefined;
  hasValue: boolean;
  isCompliant: boolean | null;
  onTemperatureChange: (value: number | undefined) => void;
  onTemperatureAdjust: (delta: number) => void;
  theme: Theme;
}

export function TemperatureInputControls({
  temperature,
  validation,
  hasValue,
  isCompliant,
  onTemperatureChange,
  onTemperatureAdjust,
  theme,
}: TemperatureInputControlsProps) {
  const temperatureStep = 0.1;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: { xs: 1, sm: 1.5 },
      }}
    >
      <TemperatureAdjustButton
        direction="decrease"
        disabled={temperature === undefined}
        onAdjust={() => onTemperatureAdjust(-temperatureStep)}
        theme={theme}
      />

      <TemperatureInput
        temperature={temperature}
        validation={validation}
        hasValue={hasValue}
        isCompliant={isCompliant}
        onChange={onTemperatureChange}
      />

      <TemperatureAdjustButton
        direction="increase"
        disabled={temperature === undefined}
        onAdjust={() => onTemperatureAdjust(temperatureStep)}
        theme={theme}
      />
    </Box>
  );
}
